/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_Cta_LeadInputs */

const en_cmp_cta_lead = /** @type {(inputs: Cmp_Cta_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import your existing spec or backlog, let Bystep add acceptance criteria and a verification gate, and keep working with the agent you already use.`)
};

const id_cmp_cta_lead = /** @type {(inputs: Cmp_Cta_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impor spec atau backlog yang sudah Anda punya, biarkan Bystep menambahkan kriteria penerimaan dan gerbang verifikasi, lalu tetap bekerja dengan agen yang sudah Anda pakai.`)
};

/**
* | output |
* | --- |
* | "Import your existing spec or backlog, let Bystep add acceptance criteria and a verification gate, and keep working with the agent you already use." |
*
* @param {Cmp_Cta_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_cta_lead = /** @type {((inputs?: Cmp_Cta_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Cta_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_cta_lead(inputs)
	return en_cmp_cta_lead(inputs)
});